window.arjoInvestorsNewsArticleListModule =
  window.arjoInvestorsNewsArticleListModule ||
  (() => {
    const state = {
      isInitialized: false,
      elements: {},
    };

    const classNamePrefix = 'arjo-o-investors-news-article-list';

    const setUp = () => {
      const elements = [...document.querySelectorAll(`.${classNamePrefix}`)];
      elements.forEach((el) => {
        const articleListId = el.dataset.articleListId;

        if (!articleListId) return;
        state.elements[articleListId] = (() => {
          const innerState = {
            data: [],
          };

          const ga4Event = (header) => {
            window.GA4.analyticsGa4.CTATracker.pushCTA('Clickable link', 'CTA block', header, 'arjo-o-investors-news-article-item__wrapper', '');
          };

          const getLinkElement = (target) => {
            return target.querySelector('.arjo-o-investors-news-article-item__link');
          }

          const onItemClick = (event) => {
            const link = getLinkElement(event.currentTarget);

            if (link) {
              ga4Event(link.innerText);
              link.click();
            }
          };

          const onItemMouseDown = (event) => {
            if (event.button === 1) {
              const link = getLinkElement(event.currentTarget);

              if (link) {
                ga4Event();
                window.open(link.href, '_blank')?.focus();
              }
            }
          }


          const addEventToItems = (resultsDom = el) => {
            const items = resultsDom.querySelectorAll(`.${classNamePrefix}__item`);

            items.forEach((item) => {
              item.addEventListener('click', onItemClick);
              item.addEventListener('mousedown', onItemMouseDown);
            });
          };

          addEventToItems(el);

          const createCategory = (category) => {
            let html = '';
            [].forEach.call(category, (c) => {
              html += `<div class="arjo-o-investors-news-article-item__category-item">${c}</div>`;
            });

            return html;
          };

          const createArticleEntry = ({ category, date, header, url, text, articleImage, cssBackground }) => {
            return `
              <div class="arjo-o-investors-news-article-list__item">
              <div class="arjo-o-investors-news-article-item ${cssBackground}">
              <div class="arjo-o-investors-news-article-item__wrapper">
                  <div class="arjo-o-investors-news-article-item__content">
                  <span class="arjo-o-investors-news-article-item__date">${date}</span>
                    <h4 class="arjo-o-investors-news-article-item__header">
                      <a class="arjo-o-investors-news-article-item__link" href="${url}">
                        ${header}
                      </a>
                    </h4>
                    <p class="arjo-o-investors-news-article-item__text">${text}</p>
                  </div>
                  <div class="arjo-o-investors-news-article-item__category">
                    ${createCategory(category)}
                  </div>
                  <div class="arjo-o-investors-news-article-item__image">
                    <picture class="arjo-a-picture"><img src="${articleImage.src}" alt="${articleImage.alt}" loading="lazy"></picture>
                  </div>
                </div>
            </div>
            `;
          };

          const updateDom = () => {
            const resultsDom = el.querySelector(`.${classNamePrefix}__wrapper`);
            if (innerState.data.length === 0) {
              resultsDom.innerHTML = '';
              el.classList.add('empty');
            } else {
              el.classList.remove('empty');
              resultsDom.innerHTML = '';
              const entries = [...innerState.data];
              entries.forEach((entry) => {
                resultsDom.innerHTML += createArticleEntry(entry);
              });

              addEventToItems(resultsDom);
            }
          };

          const setState = ({ data }) => {
            innerState.data = [].concat([...data]);
            updateDom();
          };

          return {
            setState,
            get data() {
              return [...innerState.data];
            },
          };
        })();
      });
    };
    const init = () => {
      if (state.isInitialized) return;
      setUp();
      state.isInitialized = true;
    };

    const getElement = (id) => state.elements[id];
    return { init, getElement };
  })();

window.addEventListener('load', window.arjoInvestorsNewsArticleListModule.init);
